import {shallowEqual, useSelector} from 'react-redux';
import {Product} from '../Model/Product';
import {RootState} from '../Store';

export const useFavoriteProducts = () => useSelector<RootState, Product[]>(state => state.product.filter(({id}) => state.favorite.includes(id)), shallowEqual);
